<template>
<div id="app">
  <b-navbar toggleable="lg" type="dark" variant="primary" v-if="!$route.meta.noLayout">
    <b-navbar-brand href="#">SafeNot</b-navbar-brand>

    <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

    <b-collapse id="nav-collapse" is-nav v-if="isLoggedIn">
      <b-navbar-nav>
        <b-nav-item to="/company">Company</b-nav-item>
        <b-nav-item to="/department" v-if="$store.getters.inRole('Admin')">Department</b-nav-item>
        <b-nav-item to="/person">Person</b-nav-item>
        <b-nav-item to="/education">Education</b-nav-item>
                
        <b-nav-item-dropdown text="Settings" right v-if="$store.getters.inRole('Admin')">
          <b-dropdown-item to="/educationtype">Education type</b-dropdown-item>
          <b-dropdown-item to="/companyfiletype">Company filetype</b-dropdown-item>
          <b-dropdown-item to="/notifications">Notifications</b-dropdown-item>
        </b-nav-item-dropdown>
      </b-navbar-nav>

      <b-navbar-nav class="ml-auto">
        <b-nav-item-dropdown text="User" right>
          <b-dropdown-item @click="logout">Log out</b-dropdown-item>
        </b-nav-item-dropdown>
      </b-navbar-nav>
    </b-collapse>
  </b-navbar>
    
  <router-view/>
</div>
</template>

<script>
//import axios from 'axios';

export default {
  computed: {
    isLoggedIn() { return this.$store.getters.isLoggedIn }
  },
  methods: {
    logout() {
      this.$store.dispatch('logout')
      .then(() => {
        this.$router.push('/login')
      })
    }
  }
}
</script>

<style>
  html, body, #app {
    height: 100%;
  }
</style>